// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ov-0";
export var buttonContainer = "_ov-3";
export var cancelButton = "_ov-4";
export var headerSection = "_ov-6";
export var headerTitle = "_ov-9";
export var messageSideLeft = "_ov-1";
export var messageSideRight = "_ov-2";
export var orderNumberContainer = "_ov-7";
export var orderNumberLabel = "_ov-8";
export var submitButton = "_ov-5";